import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { EDSFiltersRequestBody } from '@/features/eds/types/api/requests/EDSFiltersRequestBody';
import type { GetRecentActivitiesListResponse } from '../types/api/responses/GetRecentActivitiesListResponse';
import { recentActivityInitialState } from './constants/recentActivitySliceConstants';

const recentActivitySlice = createSlice({
  name: 'recentActivity',
  initialState: recentActivityInitialState,
  reducers: {
    getRecentActivityList: (state, _action: PayloadAction<{ id: number | string }>) => {
      state.statuses.getRecentActivityList.isLoading = true;
      state.data.pagination = recentActivityInitialState.data.pagination;
    },
    getRecentActivityListSuccess: (
      state,
      {
        payload: { shouldRewrite = true, data },
      }: PayloadAction<{ data: GetRecentActivitiesListResponse; shouldRewrite?: boolean }>,
    ) => {
      if (shouldRewrite) {
        state.data.listings = [...data.listings];
        state.data.pagination = data.pagination;
      } else {
        state.data.listings = [...state.data.listings, ...data.listings];
        state.data.pagination = data.pagination;
      }

      state.statuses.getRecentActivityList.isLoading = false;
    },
    incrementRecentActivityListPage(state) {
      state.data.pagination.page++;
    },
    updateRecentActivitySavedFiltersForSending: (state, { payload }: PayloadAction<EDSFiltersRequestBody>) => {
      state.savedFiltersForSending = payload;
    },
    resetRecentActivitySlice: () => recentActivityInitialState,
  },
});

export const {
  getRecentActivityList,
  getRecentActivityListSuccess,
  incrementRecentActivityListPage,
  updateRecentActivitySavedFiltersForSending,
  resetRecentActivitySlice,
} = recentActivitySlice.actions;

export const recentActivityReducer = recentActivitySlice.reducer;
export const recentActivityReducerPath = recentActivitySlice.reducerPath;
